var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 18,
    viewBox: "0 0 25 18",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.5221 3.18492C23.3864 2.67434 23.119 2.20834 22.7466 1.83358C22.3743 1.45881 21.91 1.18842 21.4003 1.04947C19.5239 0.544922 12.0239 0.544922 12.0239 0.544922C12.0239 0.544922 4.52393 0.544922 2.64756 1.04947C2.13786 1.18842 1.67358 1.45881 1.30121 1.83358C0.928842 2.20834 0.661431 2.67434 0.525744 3.18492C0.0239258 5.06947 0.0239258 8.99947 0.0239258 8.99947C0.0239258 8.99947 0.0239258 12.9295 0.525744 14.814C0.661431 15.3246 0.928842 15.7906 1.30121 16.1654C1.67358 16.5401 2.13786 16.8105 2.64756 16.9495C4.52393 17.454 12.0239 17.454 12.0239 17.454C12.0239 17.454 19.5239 17.454 21.4003 16.9495C21.91 16.8105 22.3743 16.5401 22.7466 16.1654C23.119 15.7906 23.3864 15.3246 23.5221 14.814C24.0239 12.9295 24.0239 8.99947 24.0239 8.99947C24.0239 8.99947 24.0239 5.06947 23.5221 3.18492Z",
    fill: "#FF0302"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.5694 12.5681V5.43086L15.8421 8.9995L9.5694 12.5681Z",
    fill: "#FEFEFE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.c509fd7fac8e925d354181a77c8913f5.svg";
export { ForwardRef as ReactComponent };